







































































import {Component, Emit, Prop, Vue, Watch} from 'vue-property-decorator'
import { HTTP } from '@/plugins/axios'

@Component
export default class LoginCortesias extends Vue {
  @Prop({ type: Object })
  private info!: object

  private token: boolean = this.$store.state.auth.token
  private loading: boolean = false
  private data: object = {
    user: '',
    pass: ''
  }
  private errorLogin: boolean = false

  private errorLoginMSG: string = 'Por favor verifique el correo electronico y/o password.'

  @Emit('info')
  private emitInfo (v: any) {
    console.log('emitInfo :: ', v)
    if (v.success) {
      this.$emit('update:info', v)
    }
  }

  private Login () {
    console.log('Login :: ', this.data)
    this.loading = true
    this.errorLogin = false
    HTTP.post('boleto-especial/login', this.data)
      .then((response) => {
        console.log('LoginCortesia :: response :: ', response.data)
        if (response.data.success) {
          this.emitInfo(response.data)
        }
      })
      .catch((e) => {
        console.log('LoginCortesia :: catch :: ', e.response.data)
        this.errorLogin = true
      })
      .finally(() => {
        this.loading = false
      })
  }
}
